export default "__VITE_ASSET__BrovPgX1__"